import { PROGRESS_BAR_SET_LENGTH } from '../actions/progress-bar-actions';
import { PROGRESS_BAR_RESET } from '../actions/actionTypes/progress-bar-action-types';

export default (state = { width: null }, action) => {
    switch (action.type) {
        case PROGRESS_BAR_SET_LENGTH: {
            const { width } = action;
            return { width };
        }
        case PROGRESS_BAR_RESET: {
            return { width: null };
        }
        default:
            return state;
    }
};
